/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/design/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchDesigns ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/design-management/designes')
        .then((response) => {
          commit('SET_PROJECTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDesign (context, designId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/design-management/designes/${designId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord ({ commit }, designId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/design-management/designes/${designId}`)
        .then((response) => {
          commit('REMOVE_RECORD', designId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
